import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ContactProvider } from "./core/context/ContactContext";
import {
  GalleryLayout,
  GalleryHome,
  ServicePage,
  NotFound,
} from "./gallery/Gallery";
import "./gallery/gallery.css";

export default function App() {
  return (
    <ContactProvider>
      <BrowserRouter>
        <GalleryLayout>
          <Routes>
            <Route path="/" element={<GalleryHome />} />
            <Route path="/services/:slug" element={<ServicePage />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </GalleryLayout>
      </BrowserRouter>
    </ContactProvider>
  );
}
